import {
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
  MDSText,
  MDSTextVariant,
  MDSTextColor,
  MDSTextWeight,
} from "@/mds";
import type { NotesListPageCalendarSyncStatusViewProps } from "./notes-list-page-calendar-sync-status.types";
import {
  StyledStatusContainer,
  StyledStatusContent,
  StyledCalendarInfo,
} from "./notes-list-page-calendar-sync-status.style";

/**
 * View component for displaying calendar sync status.
 * Shows the status with the first calendar name and "+ X more" if multiple.
 */
export const NotesListPageCalendarSyncStatusView = ({
  status,
  calendarLabel,
  calendarColor,
  additionalCount,
  onClick,
}: NotesListPageCalendarSyncStatusViewProps) => {
  const isFailed = status === "FAILED";
  const statusIcon = isFailed ? MDSIconKind.CloudSlash : MDSIconKind.Refresh;
  const statusIconColor = isFailed ? MDSIconColor.Danger : MDSIconColor.Placeholder;
  const statusText = isFailed ? "Failed to reconnect" : "Trying to reconnect";
  const statusTextColor = isFailed ? MDSTextColor.Danger : MDSTextColor.Tertiary;
  const labelTextColor = isFailed ? MDSTextColor.Secondary : MDSTextColor.Tertiary;

  const handleClick = () => {
    if (isFailed && onClick) {
      onClick();
    }
  };

  return (
    <StyledStatusContainer $isClickable={isFailed} onClick={handleClick}>
      <StyledStatusContent>
        <MDSIcon kind={statusIcon} size={10} color={statusIconColor} />
        <MDSText variant={MDSTextVariant.TextXs} color={statusTextColor}>
          {statusText}
        </MDSText>
      </StyledStatusContent>
      <StyledCalendarInfo>
        <MDSIcon kind={MDSIconKind.Dot} size={12} overrideColor={calendarColor} />
        <MDSText
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.Regular}
          color={labelTextColor}
        >
          {calendarLabel}
          {additionalCount > 0 && ` + ${additionalCount} more`}
        </MDSText>
      </StyledCalendarInfo>
    </StyledStatusContainer>
  );
};
